<script setup lang="ts">
defineProps<{
  largeImage?: string
  title: string
  largeImageCopyright?: string | null
}>()
</script>

<template>
  <div class="relative">
    <!-- The backend stretches every cover to 1085x651 (News::registerMediaConversions);
         the ratio keeps the space reserved before the image loads.
         Temporarily loaded straight from i.banks.kg (already WebP) instead of IPX/AVIF,
         which was slow for this image. Return NuxtImg once #510 is sorted out. -->
    <img
      class="aspect-[1085/651] h-auto w-full rounded-lg object-cover"
      fetchpriority="high"
      :src="largeImage"
      :alt="title"
      width="1085"
      height="651"
    />
    <div v-if="largeImageCopyright" class="ImageCopyright">
      {{ largeImageCopyright }}
    </div>
  </div>
</template>
